export default "__VITE_ASSET__DhO47hGj__"